import { ClickFeature } from '../Constants';

export const isPlaylistClickFeature = (playContextFeature: ClickFeature): boolean =>
  Object.values(ClickFeature)
    .filter((feature) => feature.includes('PLAYLIST'))
    .includes(playContextFeature);
